import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-642039cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "el-dialog__header"
}
const _hoisted_3 = { class: "el-dialog__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-dialog__close el-icon el-icon-close" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "el-dialog__body"
}
const _hoisted_7 = {
  key: 2,
  class: "el-dialog__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_overlay = _resolveComponent("el-overlay")!
  const _directive_trap_focus = _resolveDirective("trap-focus")!

  return (_openBlock(), _createBlock(_Teleport, {
    to: "body",
    disabled: !_ctx.appendToBody
  }, [
    _createVNode(_Transition, {
      name: "dialog-fade",
      onAfterEnter: _ctx.afterEnter,
      onAfterLeave: _ctx.afterLeave,
      onBeforeLeave: _ctx.beforeLeave
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_overlay, {
          mask: _ctx.modal,
          "overlay-class": _ctx.modalClass,
          "z-index": _ctx.zIndex,
          onClick: _ctx.onModalClick
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              ref: "dialogRef",
              class: _normalizeClass([
            'el-dialog',
            {
              'is-fullscreen': _ctx.fullscreen,
              'el-dialog--center': _ctx.center,
            },
            _ctx.customClass,
          ]),
              "aria-modal": "true",
              role: "dialog",
              "aria-label": _ctx.title || 'dialog',
              style: _normalizeStyle(_ctx.style),
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_ctx.showHeader)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "title", {}, () => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
                    ], true),
                    (_ctx.showClose)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          "aria-label": "close",
                          class: "el-dialog__headerbtn",
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                        }, _hoisted_5))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.rendered)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$slots.footer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true)
            ], 14, _hoisted_1)), [
              [_directive_trap_focus]
            ]),
            _renderSlot(_ctx.$slots, "custom", {}, undefined, true)
          ]),
          _: 3
        }, 8, ["mask", "overlay-class", "z-index", "onClick"]), [
          [_vShow, _ctx.visible]
        ])
      ]),
      _: 3
    }, 8, ["onAfterEnter", "onAfterLeave", "onBeforeLeave"])
  ], 8, ["disabled"]))
}